// extracted by mini-css-extract-plugin
export var breadcrumb = "_l-0";
export var breadcrumbArrow = "_l-1";